<template>
  <nav class="account-details-nav">
    <ul class="account-details-nav-links">
      <li class="account-details-nav-link" :data-customer="accountId" :class="{active: isCurrentRoute(link.path)}" v-for="link in links">
        <!-- <a :href="basePath + link.path">{{link.name}}</a> -->
        <a :href="basePath + link.path">{{link.name}}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {

    accountId: {
      type: Number,
      required: true
    },

    account: {
      type: Object,
      required: false,
    }
  },

  methods: {

    _removeTrailingSlash (path) {
      return path.replace(/\/$/, '');
    },

    isCurrentRoute (path) {
      const {_removeTrailingSlash} = this;

      return _removeTrailingSlash(window.location.pathname) == _removeTrailingSlash(this.basePath + path);
    }
  },

  components: {},

  data () {
    return {
      basePath: `/admin/account/details/${this.accountId}`,

      links: [{
        name: 'Summary',
        path: '/'
      },{
        name: 'Account Users',
        path: '/users'
      },{
        name: 'Order Preferences',
        path: '/order-preferences'
      },{
        name: 'Plunet Settings',
        path: '/plunet'
      },{
        name: 'Connectors',
        path: '/connectors'
      },{
          name: 'Programs',
          path: '/program-preferences'
      },]
    }
  },

  computed: {},
}
</script>
